import { useRouter } from 'next/navigation';
import { useCallback } from 'react';

import InventoryOverview from '@features/inventory/InventoryOverview';

const InventoryPage = () => {
  const router = useRouter();

  const onClickPurchase = useCallback(() => {
    router.push('/marketplace');
  }, [router]);

  return <InventoryOverview onClickPurchase={onClickPurchase} />;
};

export default InventoryPage;
